import { ApiError } from '@marageti/z4-sdk/lib/tracking';
import { useApiClient, useFetchImmutable } from '@marageti/z4-lib';
import { Photo, PhotoSearchResult } from '@marageti/z4-sdk/lib/photos/Photo';
import { getCloudinaryImageUrl } from '../utils/cloudinary';

const useCloudinaryUrl = (photoId: string, dimensions: { height: number; width: number }): [
  url: string,
  isLoading: boolean,
  error: ApiError | undefined,
] => {
  const apiClient = useApiClient();

  const { data: tripPhoto, isLoading: tripPhotoLoading, error: tripPhotoError } = useFetchImmutable<Photo>(apiClient.photosClient.getPhoto, [photoId], !!photoId);
  const tripPhotoUrl = tripPhoto?.public_id && getCloudinaryImageUrl(tripPhoto.public_id, dimensions);

  // If photoId is empty string, trip photo doesn't exist or tripPhoto error, get the generic photo
  const { data: fallback, isLoading: fallbackLoading, error: fallbackError } = useFetchImmutable<PhotoSearchResult>(
    apiClient.photosClient.getCountryPhotosGeneric,
    [],
    (!photoId || tripPhotoError || (!tripPhoto && !tripPhotoLoading)),
  );
  const fallbackPhoto = fallback?.resources[0] ? fallback.resources[0].public_id : '';
  const fallbackUrl = fallbackPhoto && getCloudinaryImageUrl(fallbackPhoto, dimensions);

  return [tripPhotoUrl || fallbackUrl, tripPhotoLoading || fallbackLoading, tripPhotoError && fallbackError];
};

export default useCloudinaryUrl;
